const categoryMeta = {
  'tv-mounting':
    'Professional TV mounting services to enhance your viewing experience. Secure, sleek, and perfectly positioned. Book now for a hassle-free setup',
  'smart-home':
    'Transform your home into a smart home with our expert installation services. Control lighting, temperature, and more, all at your fingertips',
  networking:
    'Reliable home networking solutions to keep you connected. Expert setup for Wi-Fi, extenders, and more to ensure seamless internet access.',
  'television-and-audio':
    'Elevate your audio-visual experience with our TV and audio setup services. From soundbars to home theaters, get the perfect setup.',
  mobile: 'Mobile device setup and support services to keep you connected on the go. Expert assistance for smartphones, tablets, and more.',
  'home-security':
    'Secure your home with our home security installation services. Cameras, alarms, and smart locks installed by professionals for peace of mind.',
  computers: 'Comprehensive computer services from setup to support. Whether PC or Mac, we ensure your computer is running smoothly and securely.',
  'around-the-home':
    "ersatile home services to tackle any task around the house. From furniture assembly to handyman services, we've got you covered.",
};

const defaultMeta =
  'Get expert tech support and seamless installations. From setting up devices, TV Mounting, Networking etc... we ensure your technology works flawlessly.';

export const title = (category: string = '') => `${category} Service In Your Area`;

export const description = (category: string = 'services', seoName: string) =>
  `HelloTech offers you quick &amp; professional ${category} Installation &amp; Support. ${categoryMeta[seoName] || defaultMeta}. Visit hellotech.com today to get same day appointment.`;
